// Copyright (c) Bentley Systems
import { Parameter } from "../../Action/parameter";
import { Style } from "../../DataModels/style";
import { EfField } from "../DataModels/ef-field";
import { Field } from "./field-vm";

export class RecordVm {
  public recordId: number | undefined;
  public header: string | undefined;
  public recordItems: RecordItem[] = [];

  constructor(
    initializer: any,
    urlParameters: Parameter[],
    recordItems: any[] = [],
    styles: Style[] = [],
  ) {
    if (initializer.recordId) {
      this.recordId = initializer.recordId;
    }
    if (initializer.tableName) {
      this.header = initializer.tableName;
    }
    if (initializer.efFields) {
      if (
        recordItems === undefined ||
        recordItems === null ||
        recordItems.length === 0
      ) {
        const recordItem = new RecordItem();
        recordItem.fields = initializer.efFields.map(
          (f: EfField) => new Field(f, urlParameters, styles),
        );
        this.recordItems.push(recordItem);
      } else {
        recordItems.forEach((recorItemFromDataResult: any) => {
          const recordItem = new RecordItem();
          //recordItem.fields = new Field[]();
          initializer.efFields.forEach((f: { name: any }) => {
            const recordValue = recorItemFromDataResult.recordValues.find(
              (rd: { name: any }) => rd.name === f.name,
            );
            if (recordValue !== undefined) {
              recordItem.fields.push(
                new Field(f, urlParameters, styles, recordValue.value),
              );
            }
          });
          this.recordItems.push(recordItem);
        });
      }
    }
  }
}

export class RecordItem {
  public fields: Field[] = [];
}
